import DefaultSubComponet from "./components/common/SingleCardSubComponets/DefaultSubComponet";

const configs = {
  singleNewCardSubComponet: {
    component: DefaultSubComponet,
    variant: {
      v1: {
        display: ["opening-status-with-distance", "rating"],
      },
      v2: {
        display: ["opening-status-with-distance", "rating"],
      },
      v3: {
        display: ["rating"],
      }
    },
    disableEvnetNameTrancate: true,
  },
  explore: {
    layoutColumn: ["upcoming events"],
    layoutRow: [],
    cardDimension: {
      EXPERIENCES: {
        size: "large",
        additionalClass: "",
      },
      "At the Hotel": {
        size: "long",
        additionalClass: "",
      },
      "What’s Nearby":{
        size: "long",
        additionalClass: "",
        display: ["distance"],
      },
      "Explore Las Vegas":{
        size: "long-wide",
        additionalClass: "",
      },
      "R Curated List":{
        size: "long-wide",
        additionalClass: "",
      },
      "Local attractions":{
        type: "grid",
        size: "",
        additionalClass: ""
      },
      "Three Bites Away from Bliss":{
        type: "grid",
        size: "",
        additionalClass: ""
      },
      "Refined Culinary Excellence":{
        size: "small",
        additionalClass: "",
        display: ["price_level"]
      }
    },
    personaliseYourStay: {
      visible: true,
      // 98/99 are past any real group count, so both cards land at the end of
      // the list: map second-last, personalize-your-stay last.
      position: 99,
      imgSrc: "",
      content: {
        title: "Personalize Your Stay",
        subTitle: "Use our AI wizard to curate your stay",
      },
      initPage: {
        showImage: false,
        eyebrow: "Welcome to Iasi · Boutique Stays",
        title: "Welcome. Your stay begins tomorrow.",
        description:
          "Discover the best local events, attractions, and hidden gems tailored just for you. Answer a few quick questions so we can personalize your visit.",
      },
      flow: {
        alwaysShowContinue: true,
        showPrevious: true,
      },
    },
    searchOnMap: {
      visible: true,
      position: 98,
      imgSrc: "",
      content: {
        title: "Search on a Map",
        subTitle: "Get a bird's eye view",
      },
    },
    favoritesGrid:{
      visible: false,
      position: 4,
      imgSrc: "",
      content: {
        title: "",
        subTitle: "",
      },
    }
  },
  fiterComponet: {
    selection: "border",
    // selection:"class"
  },
  brand: {
    title: "Maisonelle",
  },
  initialPage: "welcome",
  bottomNav: {
    items: [
      {
        id: "explore",
        label: "Explore",
        icon: "explore",
        action: { type: "navigate", path: "trip" },
      },
      {
        id: "concierge",
        label: "Concierge",
        icon: "concierge",
        action: { type: "chatbot" },
      },
      {
        id: "hotel",
        label: "About",
        icon: "about",
        action: { type: "navigate", path: "hotel" },
      },
    ],
  },
  chat: {
    selector: "chat-maisonelle",
    placement: "nav",
  },
  fonts: {
    typekitKit: "lpu5cqy",
  },
  cards: {
    cardTypes: ["single"],
  },
  welcomePage: {
    copyright: "MAISONELLE © ALL RIGHTS RESERVED",
    buttons: [
      {
        label: "EXPLORE",
        variant: "primary",
        action: { type: "navigate", path: "trip" },
      },
      {
        label: "SPEAK TO CONCIERGE",
        variant: "secondary",
        action: { type: "chatbot" },
      },
    ],
  },
  hotelPage: {
    tabLabel: "About",
    heading: "About",
    iframeTitle: "About",
    secondImage: {
      visible: true,
    },
    cards: [
      {
        icon: "faq",
        title: "FAQs",
        subTitle: "Frequently asked questions",
        action: {
          type: "iframe",
          url: "TODO_MAISONELLE_FAQ_URL",
          trackAction: "FAQ",
        },
      },
    ],
    accordion: [
      {
        title: "Who We Are",
        text: "Maisonelle is a curated concierge service and personalized experiences platform, built in Iași and designed for national scale. We bring a layer of premium hospitality where it didn't exist before — in short-term rental apartments, aparthotels, companies, and residential communities. We don't replace the hotel. We add what was missing.",
      },
    ],
  },
};

export const translations = {};

export default configs;
